import { updateObject } from "utils/helpers/updateObject";
import { SpecialOfferState, initialState } from "./state";
import { actionTypes, CreateSpecialOfferFailureAction, CreateSpecialOfferRequestAction, CreateSpecialOfferSuccessAction, DeleteSpecialOfferFailureAction, DeleteSpecialOfferRequestAction, DeleteSpecialOfferSuccessAction, FetchSpecialOfferFailureAction, FetchSpecialOfferRequestAction, FetchSpecialOfferSuccessAction, ResetSpecialOfferAction, SpecialOfferActions, stateStatusType, UpdateSpecialOfferFailureAction, UpdateSpecialOfferRequestAction, UpdateSpecialOfferSuccessAction, UploadSpecialOfferVideoFailureAction, UploadSpecialOfferVideoRequestAction, UploadSpecialOfferVideoSuccessAction } from './actionType';

const fetchSpecialOfferRequest = (
  state: SpecialOfferState,
  action: FetchSpecialOfferRequestAction
) => {
  return updateObject(state, {
    specialOfferState: {
      ...state.specialOfferState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const fetchSpecialOfferSuccess = (
  state: SpecialOfferState,
  action: FetchSpecialOfferSuccessAction
) => {
  return updateObject(state, {
    specialOfferState: {
      ...state.specialOfferState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      specialOffer: action.payload,
    },
  });
};

const fetchSpecialOfferFail = (
  state: SpecialOfferState,
  action: FetchSpecialOfferFailureAction
) => {
  return updateObject(state, {
    specialOfferState: {
      ...state.specialOfferState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};

const createSpecialOfferRequest = (
  state: SpecialOfferState,
  action: CreateSpecialOfferRequestAction
) => {
  return updateObject(state, {
    genericSpecialOfferState: {
      ...state.genericSpecialOfferState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const createSpecialOfferSuccess = (
  state: SpecialOfferState,
  action: CreateSpecialOfferSuccessAction
) => {
    const existingSpecialOffer= state.specialOfferState.specialOffer || []
  return updateObject(state, {
    genericSpecialOfferState: {
      ...state.genericSpecialOfferState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
    },
    specialOfferState: {
      ...state.specialOfferState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      specialOffer: [...existingSpecialOffer, action.payload ],
    },
  });
};

const createSpecialOfferFail = (
  state: SpecialOfferState,
  action: CreateSpecialOfferFailureAction
) => {
  return updateObject(state, {
     genericSpecialOfferState: {
      ...state.genericSpecialOfferState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};

const updateSpecialOfferRequest = (
  state: SpecialOfferState,
  action: UpdateSpecialOfferRequestAction
) => {
  return updateObject(state, {
    genericSpecialOfferState: {
      ...state.genericSpecialOfferState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const updateSpecialOfferSuccess = (
  state: SpecialOfferState,
  action: UpdateSpecialOfferSuccessAction
) => {
    const newExistingSpecialOffer = state.specialOfferState.specialOffer?.map(
    (item) => (item.id === action.payload.id ? action.payload : item)
  ) ?? [action.payload];
  return updateObject(state, {
    genericSpecialOfferState: {
      ...state.genericSpecialOfferState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
    },
    specialOfferState: {
      ...state.specialOfferState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      specialOffer: [...newExistingSpecialOffer ],
    },
  });
};

const updateSpecialOfferFail = (
  state: SpecialOfferState,
  action: UpdateSpecialOfferFailureAction
) => {
  return updateObject(state, {
     genericSpecialOfferState: {
      ...state.genericSpecialOfferState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};
const uploadSpecialOfferVideoRequest = (
  state: SpecialOfferState,
  action: UploadSpecialOfferVideoRequestAction
) => {
  return updateObject(state, {
    genericSpecialOfferState: {
      ...state.genericSpecialOfferState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const uploadSpecialOfferVideoSuccess = (
  state: SpecialOfferState,
  action: UploadSpecialOfferVideoSuccessAction
) => {
  const existingData = state.specialOfferState.specialOffer
  return updateObject(state, {
    genericSpecialOfferState: {
      ...state.genericSpecialOfferState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
    },
    specialOfferState: {
      ...state.specialOfferState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      specialOffer: existingData,
      specialOfferVideo: action.payload
    },
  });
};

const uploadSpecialOfferVideoFail = (
  state: SpecialOfferState,
  action: UploadSpecialOfferVideoFailureAction
) => {
  return updateObject(state, {
     genericSpecialOfferState: {
      ...state.genericSpecialOfferState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};
const deleteSpecialOfferRequest = (
  state: SpecialOfferState,
  action: DeleteSpecialOfferRequestAction
) => {
  return updateObject(state, {
    genericSpecialOfferState: {
      ...state.genericSpecialOfferState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const deleteSpecialOfferSuccess = (
  state: SpecialOfferState,
  action: DeleteSpecialOfferSuccessAction
) => {
    const existingSpecialOffer= state.specialOfferState.specialOffer ?? []
    const newSpecialOffer = existingSpecialOffer.filter((item)=> item.id !== action.payload);
  return updateObject(state, {
    genericSpecialOfferState: {
      ...state.genericSpecialOfferState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
    },
    specialOfferState: {
      ...state.specialOfferState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      specialOffer: newSpecialOffer,
    },
  });
};

const deleteSpecialOfferFail = (
  state: SpecialOfferState,
  action: DeleteSpecialOfferFailureAction
) => {
  return updateObject(state, {
     genericSpecialOfferState: {
      ...state.genericSpecialOfferState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};

const resetSpecialOffer = (state: SpecialOfferState, action: ResetSpecialOfferAction) => ({
  ...state,
  genericSpecialOfferState: { ...initialState.genericSpecialOfferState },
});

const fetchSpecialOfferReducer = (state = initialState, action: SpecialOfferActions) => {
  switch (action.type) {
    case actionTypes.FETCH_SPECIAL_OFFER_REQUEST:
      return fetchSpecialOfferRequest(state, action);
    case actionTypes.FETCH_SPECIAL_OFFER_SUCCESS:
      return fetchSpecialOfferSuccess(state, action);
    case actionTypes.FETCH_SPECIAL_OFFER_FAIL:
      return fetchSpecialOfferFail(state, action);
    case actionTypes.CREATE_SPECIAL_OFFER_REQUEST:
      return createSpecialOfferRequest(state, action);
    case actionTypes.CREATE_SPECIAL_OFFER_SUCCESS:
      return createSpecialOfferSuccess(state, action);
    case actionTypes.CREATE_SPECIAL_OFFER_FAIL:
      return createSpecialOfferFail(state, action);
    case actionTypes.UPDATE_SPECIAL_OFFER_REQUEST:
      return updateSpecialOfferRequest(state, action);
    case actionTypes.UPDATE_SPECIAL_OFFER_SUCCESS:
      return updateSpecialOfferSuccess(state, action);
    case actionTypes.UPDATE_SPECIAL_OFFER_FAIL:
      return updateSpecialOfferFail(state, action);
    case actionTypes.UPLOAD_SPECIAL_OFFER_VIDEO_REQUEST:
      return uploadSpecialOfferVideoRequest(state, action);
    case actionTypes.UPLOAD_SPECIAL_OFFER_VIDEO_SUCCESS:
      return uploadSpecialOfferVideoSuccess(state, action);
    case actionTypes.UPLOAD_SPECIAL_OFFER_VIDEO_FAIL:
      return uploadSpecialOfferVideoFail(state, action);
    case actionTypes.DELETE_SPECIAL_OFFER_REQUEST:
      return deleteSpecialOfferRequest(state, action);
    case actionTypes.DELETE_SPECIAL_OFFER_SUCCESS:
      return deleteSpecialOfferSuccess(state, action);
    case actionTypes.DELETE_SPECIAL_OFFER_FAIL:
      return deleteSpecialOfferFail(state, action);
    case actionTypes.RESET_SPECIAL_OFFER:
      return resetSpecialOffer(state, action);
    default:
      return state;
  }
};

export default fetchSpecialOfferReducer;